import {Injectable} from '@angular/core';
import {FeatureFlagService} from '@ox/data';
import {isEmpty} from 'lodash';
import {lastValueFrom, map, take} from 'rxjs';
@Injectable()
export class ShopVariationService {

  constructor(private flagService: FeatureFlagService) { }

  callVariation = async (product: string) => {
    const productVariation = `SHOP_${product.toUpperCase()}.VARIATION`;
    return await lastValueFrom(this.flagService.getDifferentVariation(productVariation).pipe(
      take(1),
      map(res =>  !isEmpty(res) ? res.toString() : '')
    ));
  };
}
